import { parsePhoneNumberFromString } from 'libphonenumber-js';
import Constants from '@/utils/constants';

const Country = {
    UK: {
        TelephoneCode: '+44',
        Code: 'UK',
        Id: 72
    },
    US: {
        TelephoneCode: '+1',
        Code: 'US',
        Id: 220
    }
}
function removeFirstArrayItem(array) {
    return array.splice(1, array.length - 1);
}

function getUSFormatPhoneNumber(value) {
    var _match = [];
    switch (value.length) {
        case 10: // 8001112222 -> (800)
            _match = removeFirstArrayItem(value.match(/^(\d{3})(\d{3})(\d{4})$/));
            return "(" + _match[0] + ") " + _match[1] + "-" + _match[2];

        case 11: // 18001112222 -> 1-800-111-2222
            return removeFirstArrayItem(value.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/)).join("-");

        default:
            return value;
    }
}

function getUKFormatPhoneNumber(value) {
    var _match = [];
    switch (value.length) {
        case 10: // 8001112222 -> 80 0 111 2222
            return removeFirstArrayItem(value.match(/^(\d{2})(\d{1})(\d{3})(\d{4})$/)).join(" ");

        case 11: // 18001112222 -> (1) 80 0 111 2222
            _match = removeFirstArrayItem(value.match(/^(\d{1})(\d{2})(\d{1})(\d{3})(\d{4})$/));
            return "(" + _match[0] + ") " + _match.splice(1, 4).join(" ");
        default:
            return value;
    }
}

export default function TelFormatter(tel, countryCode, hideTelephoneCode) {
    if (!tel) { return ''; }
    var telephoneCode,
        value = tel.toString().trim().replace(/^\+/, ''),
        countryCode = countryCode || Country.US.Code;
    
    // Skip formatting for excluded country codes
    if (Constants.lindenbaumExcludedCountryCodes.includes(countryCode)) {
        return tel;
    }
    
    if (value.match(/[^0-9]/)) {
        return tel;
    }
    const parsedPhoneNumber = parsePhoneNumberFromString(tel, countryCode);
    if (parsedPhoneNumber) {
        const format = hideTelephoneCode ? 'NATIONAL' : 'INTERNATIONAL';
        return parsedPhoneNumber.format(format);
    } else {
        return tel;
    }
/* Commenting for now will remove after confirmation
    if(countryCode === Country.US.Code) {
        telephoneCode = hideTelephoneCode ? ''  : Country.US.TelephoneCode;
        return telephoneCode + ' ' + getUSFormatPhoneNumber(value);
    } else {
        telephoneCode = hideTelephoneCode ? '' : Country.UK.TelephoneCode;
        return telephoneCode + ' ' + getUKFormatPhoneNumber(value);
    } */
};
